import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Button, Row, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { RESET_PHONE_URL } from '../../actions/url';
import { isSW } from '../../actions/root_url';

const propTypes = {
  onCloseClicked: PropTypes.func.isRequired,
  selectedUserId: PropTypes.string.isRequired,
};

const phoneRegex = /^\s*(?:\+?1[\s.-]?)?(?:\(?([2-9]\d{2})\)?[\s.-]?)([2-9]\d{2})[\s.-]?(\d{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?\s*$/;

class ResetPhoneModal extends Component {
  constructor() {
    super();
    this.state = {
      inputText: '',
      errors: '',
    };
  }

  resetPhone = (phone) => {
    let errors = ''

    // check validation
    if (!phone) {
      errors = 'Phone field cannot be empty';
    } else if (!(phoneRegex.test(phone))) {
      errors = 'Phone number is not valid';
    }
 
    const url = RESET_PHONE_URL + this.props.selectedMobileUserId + '/'; // MobileUser_id
    if (errors === '') {
      axios.put(
        url,
        {
          username: phone,
        },
        {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        },
      ).then((response) => {
        if (response.status === 200) {
          alert(`Reset phone to: ${phone}`);
          this.props.handleDispatcherBindSuccess(); // need to refresh data in parent component
        }
        this.props.onCloseClicked();
        this.setState({
          errors: '',
        });
      })
        .catch((error) => {
          alert(JSON.stringify(error.data));
        });
    } else {
      this.setState({ errors });
    }
  };

  render() {
    const { inputText, errors } = this.state;
    return (
      <div>
        <Row>
          <div className="text-center" style={{ marginTop: '20px' }}>
            <h3><Translate value="new_phone_number" /></h3>
          </div>
        </Row>
        <Row>
          <div className="col-xs-4 col-xs-offset-4">
            <Input
              type="text"
              onChange={event => this.setState({ inputText: event.target.value })}
            />
          </div>
          <div className="col-xs-1 col-xs-offset-5" style={{ marginTop: '50px' }}>
            <Button
              bsStyle="primary"
              onClick={() => { this.resetPhone(inputText); }}
            >
              <em className="fa fa-check" /><Translate value="Confirm" />
            </Button>
          </div>
        </Row>
        <br />
        <Row>
          {errors !== '' && <div className="alert alert-danger"><Translate value={errors} /></div>}
        </Row>
      </div>
    );
  }
}

ResetPhoneModal.propTypes = propTypes;
export default ResetPhoneModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Settings/ResetPhoneModal.jsx